export default "__VITE_ASSET__B5WU_KKK__"